import type { ReactNode } from "react";

const GAP_CLASS = {
  control: "gap-1",
  related: "gap-2",
  peer: "gap-3",
  group: "gap-4",
  section: "gap-6",
};

type SiblingGap = keyof typeof GAP_CLASS;

interface SiblingLayoutProps {
  children: ReactNode;
  /**
   * Express sibling spacing with `Stack`/`Inline` as relationships, not raw gap or space utilities.
   * Choose `control` for parts of one control, `related` for tightly related
   * content, `peer` for separate siblings in one group, `group` for groups
   * within a section, and `section` for page sections.
   */
  gap: SiblingGap;
}

/** Arranges siblings vertically with relationship-based spacing. */
export function Stack({ children, gap }: SiblingLayoutProps) {
  return <div className={`flex flex-col ${GAP_CLASS[gap]}`}>{children}</div>;
}

/** Arranges siblings horizontally with relationship-based spacing. */
export function Inline({ children, gap }: SiblingLayoutProps) {
  return <div className={`flex items-center ${GAP_CLASS[gap]}`}>{children}</div>;
}
